export const contact = {
  contactHero: {
    title: 'INQUIRY',
    subtitle: '联系事务局',
    description1: '我们接受关于组织变革或您自身结构性成长的咨询。',
    description2: '为应对来自世界各地的访问，事务局原则上将在3个工作日（JST）内回复。',
  },
  form: {
    title: '联系表单',
    name: '姓名',
    namePlaceholder: '您的姓名',
    email: '电子邮件',
    emailPlaceholder: 'your@email.com',
    organization: '组织/所属',
    organizationPlaceholder: '公司名称或教育机构名称',
    departmentTitle: '部门・职位',
    departmentTitlePlaceholder: '例：销售部，经理',
    inquiryType: '咨询类型',
    selectPlaceholder: '请选择',
    inquiryTypes: {
      individual: '个人项目咨询',
      corporate: '企业培训',
      educational: '教育机构导入',
      seminar: '研讨会/工作坊',
      other: '其他',
    },
    message: '留言',
    messagePlaceholder: '请详细描述您的咨询内容',
    submit: '提交',
    submitting: '提交中...',
    success: '您的咨询已提交。我们将在3个工作日内与您联系。',
    error: '提交时发生エラー。お再試しください。',
    charCount: '{{count}} / 500字',
    gratitudeMessage1: '感谢您与我们的理念产生共鸣，并找到了这里。期待与您共同迈向由教育与结构引领の崭新未来。',
    gratitudeMessage2: '"We extend our deepest gratitude for your resonance with our philosophy. We look forward to embarking on a journey toward a newly structured future together."',
  },
};